const AUTO_TIMER_SYNC_EVENT = "cherrypik:auto-timer-sync";
const AUTO_TIMER_EVENT = "cherrypik:auto-timer-event";
const AUTO_TIMER_SESSION_KEY = "ems_auto_timer_session_started_at";
const AUTO_TIMER_RUNTIME_STATE_KEY = "ems_auto_timer_runtime_state";
const AUTO_TIMER_MODE_KEY = "ems_auto_timer_mode";

export function dispatchAutoTimerExtensionSync(detail) {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(new CustomEvent(AUTO_TIMER_SYNC_EVENT, { detail }));
}

export function subscribeToAutoTimerExtensionEvents(callback) {
  if (typeof window === "undefined") {
    return () => {};
  }

  const handler = (event) => {
    callback(event.detail || {});
  };

  window.addEventListener(AUTO_TIMER_EVENT, handler);

  return () => {
    window.removeEventListener(AUTO_TIMER_EVENT, handler);
  };
}

export function getAutoTimerSessionStartedAt() {
  if (typeof window === "undefined") {
    return null;
  }

  const rawValue = window.localStorage.getItem(AUTO_TIMER_SESSION_KEY);
  const parsedValue = Number(rawValue);

  return Number.isFinite(parsedValue) && parsedValue > 0 ? parsedValue : null;
}

export function ensureAutoTimerSessionStartedAt() {
  const existingValue = getAutoTimerSessionStartedAt();
  if (existingValue) {
    return existingValue;
  }

  const newValue = Date.now();
  setAutoTimerSessionStartedAt(newValue);
  return newValue;
}

export function setAutoTimerSessionStartedAt(value) {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.setItem(AUTO_TIMER_SESSION_KEY, String(value));
}

export function clearAutoTimerSessionStartedAt() {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.removeItem(AUTO_TIMER_SESSION_KEY);
}

export function getAutoTimerMode() {
  if (typeof window === "undefined") {
    return "at_work";
  }

  const rawValue = window.localStorage.getItem(AUTO_TIMER_MODE_KEY);
  return rawValue === "in_meeting" ? "in_meeting" : "at_work";
}

export function setAutoTimerMode(value) {
  if (typeof window === "undefined") {
    return;
  }

  const nextValue = value === "in_meeting" ? "in_meeting" : "at_work";
  window.localStorage.setItem(AUTO_TIMER_MODE_KEY, nextValue);
}

export function clearAutoTimerMode() {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.removeItem(AUTO_TIMER_MODE_KEY);
}

export function getAutoTimerRuntimeState() {
  if (typeof window === "undefined") {
    return {};
  }

  try {
    const rawValue = window.localStorage.getItem(AUTO_TIMER_RUNTIME_STATE_KEY);
    return rawValue ? JSON.parse(rawValue) : {};
  } catch (error) {
    return {};
  }
}

export function setAutoTimerRuntimeState(value) {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.setItem(
    AUTO_TIMER_RUNTIME_STATE_KEY,
    JSON.stringify(value || {})
  );
}

export function clearAutoTimerRuntimeState() {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.removeItem(AUTO_TIMER_RUNTIME_STATE_KEY);
}

export {
  AUTO_TIMER_EVENT,
  AUTO_TIMER_MODE_KEY,
  AUTO_TIMER_SYNC_EVENT,
  AUTO_TIMER_RUNTIME_STATE_KEY,
  AUTO_TIMER_SESSION_KEY,
};
